import React from 'react';

import CookieConsent from './cookie-consent';
import CookieOffsetBox from './cookie-offset-box';

interface BannerHeights {
  DESKTOP: string;
  MOBILE: string;
}

interface CookieConsentWrapperProps {
  children: React.ReactNode;
  bannerHeights: BannerHeights;
}

export const CookieConsentWrapper = ({ children, bannerHeights }: CookieConsentWrapperProps) => (
  <>
    <CookieConsent bannerHeights={bannerHeights} />
    <CookieOffsetBox bannerHeights={bannerHeights}>{children}</CookieOffsetBox>
  </>
);
